import { Component } from '@angular/core';
import { GungAppComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-gung-app',
    templateUrl: './sjoborg-gung-app.component.html',
    styleUrl: './sjoborg-gung-app.component.scss',
    standalone: false
})
export class SjoborgGungAppComponent extends GungAppComponent {}
